<template>
  <div>
    <div class="oficina-tabs">
      <button
        v-for="tab in step.tabs"
        :key="tab.id"
        class="oficina-tab"
        :class="{ active: activeTab === tab.id }"
        @click="updateTab(tab.id)"
      >
        <span :class="getIconClass(tab.icon)"></span> {{ tab.label }}
      </button>
    </div>
    <div class="oficina-tab-content">
      <div v-if="activeTab === 'evaluate'">
        <div class="eval-section">
          <div class="eval-header">
            <i class="icofont-star"></i>
            <h3>Avaliação do treinamento</h3>
          </div>
          <p class="eval-subtext">
            Antes de encerrarmos, verifiquem se todas as presenças dos profissionais foram registradas corretamente no eSUS Feedback e se todos que participaram desta oficina fizeram o registro de participação.
          </p>
          <div class="social-box eval-box">
            <p class="eval-main-text">
              A avaliação formal desta oficina será realizada posteriormente, a partir das informações consolidadas nos certificados.
            </p>
            <p class="eval-detail-text">
              Para registrar a presença e depois garantir a carga horária no certificado, oriente os profissionais a:
              <br />
              <br />
              <strong>Durante a oficina (registro de participação):</strong>
              <br />
              1. Acessar <strong>Oficinas, Reuniões e Treinamentos &gt; Sou Participante</strong> no eSUS Feedback.
              <br />
              2. Na aba <strong>Em Andamento</strong>, localizar esta oficina.
              <br />
              3. Clicar em <strong>Participar</strong> antes do término da oficina.
              <br />
              <br />
              <strong>Após o término da oficina (avaliação):</strong>
              <br />
              1. Acessar novamente <strong>Oficinas, Reuniões e Treinamentos &gt; Sou Participante</strong> no eSUS Feedback.
              <br />
              2. Localizar esta oficina na aba de <strong>Finalizadas</strong>.
              <br />
              3. Realizar a <strong>avaliação</strong> da oficina para que a carga horária seja computada e vinculada ao certificado.
            </p>
          </div>
        </div>
      </div>
      <div v-else-if="activeTab === 'social'">
        <div class="social-section">
          <div class="social-icon">
            <i class="icofont-share-alt"></i>
          </div>
          <h3>"{{ currentTab.content }}"</h3>
          <div class="social-box">
            <p class="social-subtext">{{ currentTab.subtext }}</p>
            <p class="social-action">{{ currentTab.action }}</p>
          </div>
        </div>
      </div>
      <div v-else-if="activeTab === 'photos'">
        <div class="photos-section">
          <h3>{{ currentTab.content }}</h3>
          <p class="photos-subtext">{{ currentTab.subtext }}</p>
          <div v-if="currentTab.whatsappNumber" class="qr-section">
            <div class="qr-container">
              <div class="oficina-qr-code">
                <img :src="qrCodeUrl" alt="QR Code WhatsApp" />
              </div>
              <div class="qr-info">
                <div class="qr-header">
                  <p>Suporte eSUS Feedback</p>
                  <button type="button" @click="copyWhatsappLink" class="copy-btn" title="Copiar link do WhatsApp">
                    <span class="oficina-icon-copy"></span>
                  </button>
                </div>
                <p class="qr-number">{{ formattedWhatsapp }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getQRCodeUrl, getWhatsappUrl, formatPhoneNumber, copyToClipboard } from '../../utils'

export default {
  name: 'TabbedEvaluationSlide',
  props: {
    step: {
      type: Object,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    activeTabs: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    activeTab() {
      const saved = this.activeTabs && this.activeTabs.eval
      if (saved && this.step.tabs.some(t => t.id === saved)) {
        return saved
      }
      if (this.step.tabs.some(t => t.id === 'evaluate')) {
        return 'evaluate'
      }
      return this.step.tabs.length > 0 ? this.step.tabs[0].id : 'evaluate'
    },
    currentTab() {
      return this.step.tabs.find((t) => t.id === this.activeTab) || this.step.tabs[0]
    },
    qrCodeUrl() {
      if (!this.currentTab.whatsappNumber) return ''
      return getQRCodeUrl(getWhatsappUrl(this.currentTab.whatsappNumber))
    },
    formattedWhatsapp() {
      if (!this.currentTab.whatsappNumber) return 'Não informado'
      return formatPhoneNumber(this.currentTab.whatsappNumber)
    },
  },
  methods: {
    updateTab(tabId) {
      this.$emit('update-tab', 'eval', tabId)
    },
    getIconClass(icon) {
      if (icon === 'Star') return 'icofont-star'
      if (icon === 'Share2') return 'icofont-share-alt'
      if (icon === 'Camera') return 'icofont-camera'
      return 'icofont-info-circle'
    },
    async copyWhatsappLink() {
      if (!this.currentTab.whatsappNumber) return
      const link = getWhatsappUrl(this.currentTab.whatsappNumber)
      const ok = await copyToClipboard(link)
      if (ok && this.$toast) {
        this.$toast.success('Link do WhatsApp copiado!', 'Copiado', {
          position: 'topRight',
        })
      }
    },
  },
  emits: ['update-tab'],
}
</script>

<style scoped>
.oficina-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 24px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.oficina-tabs::-webkit-scrollbar {
  height: 6px;
}

.oficina-tabs::-webkit-scrollbar-track {
  background: transparent;
}

.oficina-tabs::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.oficina-tabs::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.oficina-tab {
  padding: 12px 20px;
  border: 2px solid #e2e8f0;
  border-right: none;
  background: white;
  border-radius: 0;
  cursor: pointer;
  font-weight: 600;
  color: #64748b;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

.oficina-tab:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.oficina-tab:last-child {
  border-right: 2px solid #e2e8f0;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.oficina-tab.active {
  background: #0FAFD7;
  border-color: #0FAFD7;
  color: white;
  z-index: 1;
  position: relative;
}

.oficina-tab.active + .oficina-tab {
  border-left-color: #0FAFD7;
}

.eval-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
}

.qr-code {
  margin-top: 24px;
  margin-bottom: 32px;
}

.qr-code img {
  width: 200px;
  height: 200px;
}

.eval-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
  padding: 0 16px;
}

.eval-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.copy-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #64748b;
  padding: 4px;
}

.social-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px;
}

.social-icon {
  background: linear-gradient(to right, #a855f7, #ec4899);
  padding: 12px;
  border-radius: 50%;
  color: white;
  margin-bottom: 24px;
  font-size: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
}

.social-section h3 {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
  max-width: 800px;
}

.social-box {
  background: #eff6ff;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #bfdbfe;
  max-width: 600px;
  width: 100%;
  text-align: left;
}

.eval-box {
  margin-top: 8px;
}

.eval-main-text {
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 12px;
}

.eval-detail-text {
  font-size: 14px;
  color: #1f2933;
  line-height: 1.6;
}

.social-subtext {
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 8px;
}

.social-action {
  font-size: 14px;
  color: #1e40af;
  font-style: italic;
}

.photos-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.photos-section h3 {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}

.photos-subtext {
  color: #64748b;
  margin-bottom: 32px;
  max-width: 500px;
}

.qr-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
}

.qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.oficina-qr-code {
  background: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
}

.oficina-qr-code img {
  width: 200px;
  height: 200px;
  display: block;
}

.qr-info {
  margin-top: 20px;
  text-align: center;
}

.qr-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 4px;
}

.qr-header p {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.copy-btn {
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #64748b;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 14px;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 28px;
  flex-shrink: 0;
}

.copy-btn:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #0FAFD7;
}

.copy-btn:active {
  transform: scale(0.95);
}

.qr-number {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

/* Ícone de copiar (CSS puro) */
.oficina-icon-copy {
  display: inline-block;
  width: 16px;
  height: 16px;
  position: relative;
  flex-shrink: 0;
  color: inherit;
}

.oficina-icon-copy::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 12px;
  border: 1.5px solid currentColor;
  border-radius: 2px;
  background: white;
  box-sizing: border-box;
}

.oficina-icon-copy::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 12px;
  border: 1.5px solid currentColor;
  border-radius: 2px;
  background: white;
  transform: translate(4px, 4px);
  opacity: 0.7;
  box-sizing: border-box;
}
</style>
